import Styled from 'styled-components';
import RadioField from '../../molecules/RadioField/RadioField.style';
import { VIEWPORT_SM_MIN } from '../../util/mediaQueries';
import { WIDGET_ROOT_TAG } from '../../Ids';

const flexItemPadding = '.5em';
const controlSameHeight = '3em';

export const BankLogo = Styled.div`
  #${WIDGET_ROOT_TAG} & {
    text-align: center;
    margin-bottom: 5px;
    img {
      display: initial;
      height: 43px;
      width: auto;
    }
  }
`;

export const Form = Styled.form`
  font-size: 16px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;

  ${RadioField} {
    margin-bottom: .75em;
    min-height: ${controlSameHeight};
  }
`;

const Fieldset = Styled.fieldset`
  flex: 1 1 100%;
  margin: 0;
  padding: ${flexItemPadding};
  border: none;
`;
export const CreditFieldset = Styled(Fieldset)``;
export const ContactFieldset = Styled(Fieldset)``;

export const InputContainer = Styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 10px;
  background-color: #F8F9FA;
  border-top: 1px solid #DEDEDE;
`;

export const HelpButton = Styled.div`
  position: absolute;
  right: 0;
  margin-top: -8px;
  cursor: pointer;

  span {
    position: absolute;
    right: 4px;
    top: 6px;
    font-size: 1.25em;
    color: #fff;
  }
`;

export const HelpBox = Styled.div`
  position: relative;
  background-color: #7397C1;
  color: #fff;
  padding: 5px 39px 5px 15px;
  border-radius: 3px;
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.16);
  margin-bottom: 15px;
  line-height: 24px;

  @media ${VIEWPORT_SM_MIN} {
    padding: 16px 62px;
  }
`;

export const HelpBoxClose = Styled.div`
  position: absolute;
  top: 6px;
  right: 6px;
  color: #fff;
  cursor: pointer;
`;

export const Footer = Styled.div`
  padding: ${flexItemPadding};
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  p {
   margin: 0;
  }
`;

export const LegalText = Styled.p`
  font-size: .625em;
  font-weight: bold;
  line-height: 1.25em;
  text-align:center;
  color: ${props => props.theme.labelColor};
`;

export const BestOffer = Styled.div`
  #${WIDGET_ROOT_TAG} & {
    display: flex;
    flex:1;
    flex-direction: row;
    justify-content: space-around;
    align-items: baseline;
    margin-bottom: 0.75em;
    max-width: 355px;
    margin-left: auto;
    margin-right: auto;
    min-height: ${controlSameHeight};
    font-size: 1em;
    line-height: 1em;
    font-weight: bold;
    color: ${props => props.theme.hintColor};

    output {
      font-size: 1em;
      font-weight: bold;
      line-height: 1.5em;
      color: ${props => props.theme.labelColorFocus};
    }

    label {
      display: block;
      font-size: 0.75em;
      line-height: 1em;
      font-weight: bold;
      color: ${props => props.theme.hintColor};
    }
  }
`;

export const Section = Styled.div`
    font-size: 1.25em;
    font-weight: bold;
    line-height: 1.5em;
    margin-bottom: .5em;
    text-align: center;
    color: ${props => props.theme.labelColorFocus};
`;

export const Row = Styled.div`
  display:flex;
  flex:1 1;
  flex-direction:row;
  flex-wrap:wrap;
  margin-left:-0.5em;
  margin-right:-0.5em;

  > * {
    flex: 1 1 250px;
    margin-left:0.5em;
    margin-right:0.5em;
  }
`;

export const MaxWidthRow = Styled(Row)`
  max-width: 296px;
  margin-left: auto;
  margin-right: auto;
`;

export const CenteredText = Styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 1em;
  color: #57BE4A;
`;

export const TrustElements = Styled.div`
  background-color: #F8F9FA;
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-bottom: 22px;
  border-bottom: 1px solid #DEDEDE;

  @media ${VIEWPORT_SM_MIN} {
    flex-direction: row;
  }
`;

export const TrustElement = Styled.div`
  max-width: 235px;
  margin-top: 25px;
  margin-left: 12px;
  margin-right: 12px;
  font-size: 0.875em;
`;

export const TrustTitle = Styled.div`
  font-weight: bold;
`;

export const TrustIcon = Styled.div`
  margin: 10px 0;
  &:hover {
    cursor:pointer;
  }
`;

export const TrustText = Styled.div`
`;

export const TrustQuote = Styled.div`
  font-style: italic;
`;

export const Ekomi = Styled.div`
  display: flex;
  font-size: 0.75em;
  align-items: center;
  justify-content: center;
`;

export const EkomiImage = Styled.img`
  #${WIDGET_ROOT_TAG} & {
    width: auto;
  }
`;

export const EkomiRating = Styled.div`
  text-align: left;
  margin-left: 6px;
`;

export const EkomiStars = Styled.div`
  color: #FFD55A;
`;

export const PageFooter = Styled.div`
  width: 100%;
  max-width: 1000px;
  color: #B0B9C0;
  margin: 0 auto;
  padding: 20px;
  display: flex;
  flex-direction: column-reverse;

  @media ${VIEWPORT_SM_MIN} {
    flex-direction: row;
  }
`;

export const PageFooterTextSm = Styled.div`
  margin-top: 20px;
  text-align: center;
  @media ${VIEWPORT_SM_MIN} {
    display: none;
  }
`;

export const PageFooterText = Styled.div`
  display: none;
  @media ${VIEWPORT_SM_MIN} {
    display: block;
  }
`;

export const PageFooterLinks = Styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  align-items: flex-start;

  @media ${VIEWPORT_SM_MIN} {
    margin-right: 0;
  }

  button, button:hover, button:focus, button:active, a, a:hover, a:focus, a:active {
    box-sizing:border-box;
    display:inline;
    unset:all;
    outline: 0;
    padding: 0;
    cursor:pointer;
    color: ${props => props.theme.linkColor};
    text-decoration: none;
    font-weight: normal;
    font-size: 16px;
    margin: 0 10px;
    border: none;
    background-color: transparent;
  }
`;
